<template>
  <div v-for="(item, index) in items" :key="index" class="mt-4 py-4 border-b border-black">
    <button
      :aria-expanded="isExpanded(index)"
      class="flex gap-x-4 justify-between w-full min-h-[3.55rem] text-left"
      @click="toggleItem(index)"
    >
      <span class="flex flex-col items-start gap-y-2">
        <span v-if="item.accordion_subheading" class="label-lg">{{
          item.accordion_subheading
        }}</span>
        <span class="heading-sm">{{ item.accordion_heading }}</span>
      </span>
      <span aria-hidden="true" class="shrink-0">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.127441" width="40" height="40" rx="20" fill="#111111" />
          <path
            v-if="isExpanded(index)"
            d="M22.3494 22.222H29.0161C30.2383 22.222 31.2383 21.222 31.2383 19.9998C31.2383 18.7776 30.2383 17.7776 29.0161 17.7776H22.3494H17.905H11.2383C10.0161 17.7776 9.01611 18.7776 9.01611 19.9998C9.01611 21.222 10.0161 22.222 11.2383 22.222H17.905H22.3494Z"
            fill="white"
          />
          <path
            v-else
            d="M22.3494 22.222H29.0161C30.2383 22.222 31.2383 21.222 31.2383 19.9998C31.2383 18.7776 30.2383 17.7776 29.0161 17.7776H22.3494V11.1109C22.3494 9.88867 21.3494 8.88867 20.1272 8.88867C18.905 8.88867 17.905 9.88867 17.905 11.1109V17.7776H11.2383C10.0161 17.7776 9.01611 18.7776 9.01611 19.9998C9.01611 21.222 10.0161 22.222 11.2383 22.222H17.905V28.8887C17.905 30.1109 18.905 31.1109 20.1272 31.1109C21.3494 31.1109 22.3494 30.1109 22.3494 28.8887V22.222Z"
            fill="white"
          />
        </svg>
      </span>
    </button>
    <div v-show="isExpanded(index)" class="mt-4 wysiwyg-content" v-html="item.accordion_text"></div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  items: { accordion_subheading: string; accordion_heading: string; accordion_text: string }[]
}>()

const expandedItems = ref<boolean[]>(props.items.map(() => false))

const toggleItem = (index: number) => {
  expandedItems.value[index] = !expandedItems.value[index]
}

const isExpanded = (index: number) => expandedItems.value[index]
</script>
<style></style>
